import { Group, Text } from '@mantine/core';

interface LogoProps {
  size?: number;
  withText?: boolean;
}

export function Logo({ size = 28, withText = true }: LogoProps) {
  return (
    <Group gap={8} wrap="nowrap">
      <img src="/favicon.svg" width={size} height={size} alt="" aria-hidden />
      {withText && (
        <Text fw={700} fz={size * 0.68} lh={1}>
          Firetracker
        </Text>
      )}
    </Group>
  );
}
